const reducers = {
  setLoading: (state, action) => {
    state.loading = action.payload
  },
  setCart: (state, action) => {
    state.id = action.payload?.id;
    state.items = action.payload?.cartItems || [];
    state.subtotal = action.payload?.subtotal;
  },
  setEngraving: (state, action) => {
    state.engraving = {
      ...state.engraving,
      ...action.payload
    }
  },
  setSelectedEngraving: (state, action) => {
    state.selectedEngraving = action.payload;
  },
  updateItem: (state, action) => {
    const { identifier } = action.payload
    const item = state.items.find(item => item.identifier === identifier)

    if (item) {
      Object.assign(item, action.payload)
    } else {
      state.items.push(action.payload)
    }
  },
  removeItem: (state, action) => {
    const { identifier } = action.payload
    state.items = state.items.filter(item => item.identifier !== identifier)
  },
  addRemovedItem: (state, action) => {
    state.removedItems = [...state.removedItems ?? [], action.payload]
  },
  clearRemovedItems: (state) => {
    state.removedItems = [];
  },
  setBundle: (state, action) => {
    state.bundle = action.payload
  }
}

export default reducers
